import { Injectable } from '@angular/core';

export type AppLanguage = 'es' | 'en';

const LANGUAGE_KEY = 'beetrics.settings.language';
const DEFAULT_LANGUAGE: AppLanguage = 'es';
const SUPPORTED_LANGUAGES: AppLanguage[] = ['es', 'en'];

@Injectable({ providedIn: 'root' })
export class PreferencesService {
  getLanguage(): AppLanguage {
    const stored = localStorage.getItem(LANGUAGE_KEY);
    return SUPPORTED_LANGUAGES.includes(stored as AppLanguage)
      ? (stored as AppLanguage)
      : DEFAULT_LANGUAGE;
  }

  setLanguage(lang: AppLanguage): void {
    localStorage.setItem(LANGUAGE_KEY, lang);
  }
}
